import { __extends } from "tslib";
import { EventBase } from '@awayjs/core';
var LightEvent = /** @class */ (function (_super) {
    __extends(LightEvent, _super);
    function LightEvent(type) {
        return _super.call(this, type) || this;
    }
    //@override
    LightEvent.prototype.clone = function () {
        return new LightEvent(this.type);
    };
    LightEvent.CASTS_SHADOW_CHANGE = 'castsShadowChange';
    return LightEvent;
}(EventBase));
export { LightEvent };
